<script lang="ts" setup>
import type { NuxtError } from '#app';
import PigletNotFound from '~/assets/piglet-not-found.png';

const props = defineProps<{
  error: NuxtError
}>();

const errorMessage = computed(() => {
  switch (props.error.statusCode) {
    case 404:
      return 'Страница не найдена';
    default: 
      return props.error.message;
  }
});
</script>

<template>
  <nuxt-layout name="default">
    <section class="section error">
      <div class="error__wrap">
        <img 
          :src="PigletNotFound"
          class="error__image"
        >
        <div class="error__info">
          <h1 class="error__code">
            {{ error.statusCode }}
          </h1>
          <h1>{{ errorMessage }}</h1>

          <div class="error_links">
            <nuxt-link
              to="/"
            >
              Вернемся на главную?
            </nuxt-link>
            <a
              href="https://n8n.kopyl.dev/form/a8630a57-e531-4aa9-99c4-f9d0788b3a91"
              target="_blank"
            >
              Сообщить об ошибке
            </a>
          </div>
        </div>
      </div>
    </section>
  </nuxt-layout>
</template>

<style lang="scss" scoped>
.error {
  background-color: white;
  flex-grow: 1;
  display: flex;
  justify-content: center;
  align-items: center;
}

.error__wrap {
  display: flex;
  gap: 32px;
  align-items: center;
  justify-content: center;

  @media screen and (max-width: 670px) {
    flex-direction: column;
  }
}

.error__image {
  max-height: 300px;
}

.error__info {
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: start;
  text-align: left;

  @media screen and (max-width: 670px) {
    display: contents;
  }
}

.error__code {
  font: var(--disp-32);
  font-size: 96px;
}

.error_links {
  margin-top: 32px;
  display: flex;
  flex-direction: column;
  gap: 24px;
}
</style>
